import api from "./index";

export interface Announcement { id: number; title: string; body: string; path: string | null; from: string | null; at: string; read: boolean }

export const notificationsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAnnouncements: builder.query<{ items: Announcement[]; unread: number }, void>({
      query: () => ({ url: "/notifications/inbox" }),
      providesTags: ["Announcements"],
    }),
    markAnnouncementsRead: builder.mutation<{ ok: boolean }, { broadcastId?: number }>({
      query: (body) => ({ url: "/notifications/inbox/read", method: "POST", body }),
      invalidatesTags: ["Announcements"],
    }),
    deviceHealth: builder.mutation<{ registered: boolean; missing: boolean; unconfirmed: number }, { endpoint?: string; token?: string }>({
      query: (body) => ({ url: "/devices/health", method: "POST", body }),
    }),
  }),
});

export const { useGetAnnouncementsQuery, useMarkAnnouncementsReadMutation, useDeviceHealthMutation } = notificationsApi;
